import React from 'react';
import {Box, CardContent, CardMedia, Skeleton} from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import {Typography} from '@customink/pigment-react';
import './index.scss';

const SKELETON_NAME_WIDTH = 243;
const SKELETON_PLACED_MESSAGE_WIDTH = 313;
const SKELETON_DELIVERY_ESTIMATE_LABEL_WIDTH = 294;
const SKELETON_DELIVERY_ESTIMATE_DATE_WIDTH = 141;

type OrderConfirmLogoProps = {
  storeLogo: string;
  storeName: string;
};

const OrderConfirmLogo: React.FC<OrderConfirmLogoProps> = ({
  storeLogo,
  storeName
}: OrderConfirmLogoProps) => {
  return (
    <CardMedia
      className="orderConfirmBanner-logo"
      component="img"
      image={storeLogo}
      alt={storeName}
    />
  );
};

type OrderConfirmBannerProps = {
  deliveryEstimate?: string;
  storeName: string;
  storeLogo?: string;
  placeholder?: boolean;
  mobile?: boolean;
};

const OrderConfirmBanner: React.FC<OrderConfirmBannerProps> = ({
  deliveryEstimate,
  storeName,
  storeLogo,
  placeholder,
  mobile
}: OrderConfirmBannerProps) => {
  const bannerClassNames = `orderConfirmBanner${mobile ? ' mobile' : ''}`;
  return (
    <Box className={bannerClassNames}>
      <CardContent className="orderConfirmBanner-content">
        {storeLogo && !placeholder ? (
          <OrderConfirmLogo storeLogo={storeLogo} storeName={storeName} />
        ) : (
          <Typography
            display="block"
            className="orderConfirmBanner-storeName"
            variant="h5">
            {placeholder ? <Skeleton width={SKELETON_NAME_WIDTH} /> : storeName}
          </Typography>
        )}
        <Typography
          display="block"
          className="orderConfirmBanner-placedMessage"
          variant={mobile ? 'h4' : 'h3'}>
          {placeholder ? (
            <Skeleton width={SKELETON_PLACED_MESSAGE_WIDTH} />
          ) : (
            <>
              <CheckCircleOutlineRoundedIcon
                className="orderConfirmBanner-checkIcon"
                fontSize="inherit"
                color="success"
              />
              Order Placed
            </>
          )}
        </Typography>
        {deliveryEstimate ? (
          <div className="orderConfirmBanner-deliveryEstimate">
            <Typography
              display="block"
              className="orderConfirmBanner-deliveryEstimateLabel"
              variant="subHeading">
              {placeholder ? (
                <Skeleton width={SKELETON_DELIVERY_ESTIMATE_LABEL_WIDTH} />
              ) : (
                'Estimated delivery on or around:'
              )}
            </Typography>
            <Typography
              display="block"
              className="orderConfirmBanner-deliveryEstimateDate"
              variant="subHeading">
              {placeholder ? (
                <Skeleton width={SKELETON_DELIVERY_ESTIMATE_DATE_WIDTH} />
              ) : (
                deliveryEstimate
              )}
            </Typography>
          </div>
        ) : null}
      </CardContent>
    </Box>
  );
};

OrderConfirmBanner.defaultProps = {
  storeLogo: null,
  placeholder: false,
  mobile: false,
  deliveryEstimate: undefined
};

export default OrderConfirmBanner;
